import React from 'react';

// Predefined styles for common statuses
const STATUS_STYLES = {
  ACCEPT: { color: '#1a7f37', bg: '#e6f4ea' },
  REJECT: { color: '#d32f2f', bg: '#fdecea' },
  PENDING: { color: '#f57c00', bg: '#fff4e5' },
  ESCALATED: { color: '#1976d2', bg: '#e3f2fd' },
  UNDER_REVIEW: { color: '#616161', bg: '#f5f5f5' }
};

// Dynamic fallback palette
const FALLBACK_COLORS = [
  { color: '#6a1b9a', bg: '#f3e5f5' },
  { color: '#00897b', bg: '#e0f2f1' },
  { color: '#ff8f00', bg: '#fff8e1' },
  { color: '#c2185b', bg: '#fce4ec' },
  { color: '#1976d2', bg: '#e3f2fd' }
];

// Simple hash function to pick a color based on status string
const getFallbackStyle = (status) => {
  if (!status) return { color: '#616161', bg: '#f5f5f5' };
  const index =
    status.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) %
    FALLBACK_COLORS.length;
  return FALLBACK_COLORS[index];
};

// Capitalize words for display
const formatStatus = (s) =>
  s
    ?.toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

const DowngradeStatusTag = ({ status, size = 'md' }) => {
  const { color, bg } =
    STATUS_STYLES[status?.toUpperCase()] || getFallbackStyle(status);

  const sizeMap = {
    sm: { fontSize: '0.6rem', padding: '2px 8px', dotSize: 6, gap: '4px' },
    md: { fontSize: '0.75rem', padding: '4px 10px', dotSize: 8, gap: '6px' },
    lg: { fontSize: '0.85rem', padding: '6px 12px', dotSize: 10, gap: '8px' },
    xl: { fontSize: '1rem', padding: '6px 12px', dotSize: 12, gap: '8px' }
  };

  const currentSize = sizeMap[size] || sizeMap['md'];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: currentSize.gap,
        padding: currentSize.padding,
        backgroundColor: bg,
        color: color,
        fontSize: currentSize.fontSize,
        borderRadius: '999px',
        fontWeight: 500,
        textTransform: 'capitalize',
        width: 'max-content'
      }}
    >
      <span
        style={{
          width: currentSize.dotSize,
          height: currentSize.dotSize,
          borderRadius: '50%',
          backgroundColor: color
        }}
      />
      {formatStatus(status)}
    </span>
  );
};

export default DowngradeStatusTag;
